/** The page's one call, kept out of the component. Shape and envelope are `@/api/bidList`'s. */
import type { DriverBidsPage } from '@numeo/types-main-mobile'
import { fetchBidList, type BidListQuery } from '@/api/bidList'

export type DriverBidsQuery = BidListQuery

export const fetchDriverBids = (query: DriverBidsQuery, signal?: AbortSignal): Promise<DriverBidsPage> =>
    fetchBidList<DriverBidsPage>('/gluon/driver-bids', query, signal)
